import { Reducer } from "redux";

import { MasterDischargeReasonResponse } from "../models/api/Master";
import { MasterDischargeReasonDispatchTypes } from "../models/dispatchTypes/Master";
import { MasterDischargeReasonActionDispatchTypes } from "../constants/Master";

export const initialState: MasterDischargeReasonResponse = {
  loading: false,
  response: [],
  error: null
};

const MasterDischargeReasonReducer: Reducer<
MasterDischargeReasonResponse,
MasterDischargeReasonDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case MasterDischargeReasonActionDispatchTypes.MASTER_DISCHARGE_REASON_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case MasterDischargeReasonActionDispatchTypes.MASTER_DISCHARGE_REASON_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case MasterDischargeReasonActionDispatchTypes.MASTER_DISCHARGE_REASON_ERRORS: {
      return initialState;
    }
  }
  return state;
};

export default MasterDischargeReasonReducer;
